import { useMemo } from 'react';

import { useOfferCreateMutation } from '@occc-app/dataAccessLayer/offer/mutations';
import { CampaignComponentFormValues } from '@occc-app/routes/CampaignComponents/types';
import { OfferCreateInput, OfferCreateMutation } from '@occc/graphql';
import { OfferType } from '@occc-app/offerValidationService/types';
import { getTitleByOfferType } from '@occc-app/offerHelpers/utils';
import { useChainId } from '@occc-app/Chain/hooks';

export type UseOfferCreatePageParams = {
  offerType: OfferType;
  onCompleted(mutation: OfferCreateMutation): void;
  extraMutationVariables?: Partial<OfferCreateInput>;
};

export type UseOfferCreatePageReturns = {
  offerTitle: string;
  onCreate(values: CampaignComponentFormValues): Promise<any>;
  loading: boolean;
  hasError?: boolean;
  chainId: string;
};

export const useOfferCreatePageController = ({
  offerType,
  extraMutationVariables,
  onCompleted,
}: UseOfferCreatePageParams): UseOfferCreatePageReturns => {
  const chainId = useChainId();

  const [offerCreateMutation, { loading, error }] = useOfferCreateMutation({
    onCompleted,
  });

  return useMemo(() => {
    const onCreate = (values: CampaignComponentFormValues) =>
      offerCreateMutation({
        variables: {
          input: {
            chainId,
            ...extraMutationVariables,
            ...values,
          },
        },
      });

    const title = getTitleByOfferType(offerType);
    return { offerTitle: title, onCreate, loading, chainId, hasError: !!error };
  }, [offerType, loading, chainId, error, offerCreateMutation, extraMutationVariables]);
};
